import { useState } from "react";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { openHooksModalV5 } from "app/services/ModalService";
import LocationService from "pro-features/components/Modals/src/UnlockModal/LocationService";
import HooksModalV5Key from "app/constants/HooksModalV5Key";

const useEnrichmentManagement = () => {
    const [isOpen, setIsOpen] = useState(false);
    const isEnrichmentLocked = !salesSettingsHelper.isCsvEnrichmentEnabled();

    const onClickDisabledDD = () => {
        if (!isOpen && isEnrichmentLocked) {
            openHooksModalV5(
                HooksModalV5Key.SalesSolutionDefault,
                `${LocationService.getCurrentLocationTracking()}`,
                "Enrichment",
            );
        }
    };

    return {
        isOpen,
        setIsOpen,
        onClickDisabledDD,
    };
};

export default useEnrichmentManagement;
